// extracted by mini-css-extract-plugin
export default {"list":"ProductCategory_list__IY4yb","item":"ProductCategory_item__IjMbv","content":"ProductCategory_content__+6Z35","button":"ProductCategory_button__VcT65"};